export const NUMBER_OF_VISIBLE_ITEMS = 2;

export const NUMBER_OF_HIGH_PERCENTAGE_VALUE = 999999999;
